
export class UserAbridged {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  login: string;

  public deserialize(input: any): this {
    this.id = input.skylarkUserId ? input.skylarkUserId : input.id;
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    this.fullName = input.firstName + ' ' + input.lastName;
    this.login = input.login;

    return this;
  }
};
